import React, { useState } from 'react';
import AppHeader from './AppHeader';
import BottomTabBar from './BottomTabBar';
import MyTripsPage from '../pages/MyTripsPage';
import ProfilePage from '../pages/ProfilePage';
import { IconCar, IconUser } from '../ui/icons';
import { ToastProvider } from '../ui/primitives';

const TABS = [
  { id: 'trips', label: 'My Trips', icon: <IconCar size={18} /> },
  { id: 'profile', label: 'Profile', icon: <IconUser size={18} /> },
];

function DriverApp({ authSession, userName, onLogout }) {
  const [activeTab, setActiveTab] = useState('trips');

  const renderTab = () => {
    switch (activeTab) {
      case 'trips':
        return <MyTripsPage authSession={authSession} />;
      case 'profile':
        return <ProfilePage authSession={authSession} onLogout={onLogout} />;
      default:
        return null;
    }
  };

  return (
    <ToastProvider>
      <div className="flex flex-col h-[100dvh] max-w-[700px] mx-auto bg-white sm:shadow-pop">
        <AppHeader userName={userName} onLogout={onLogout} subtitle="DRIVER" variant="driver" />
        {renderTab()}
        <BottomTabBar tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} />
      </div>
    </ToastProvider>
  );
}

export default DriverApp;
